// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style-chooser .vs__dropdown-menu .vs__dropdown-option--disabled{display:none}", ""]);
// Exports
module.exports = exports;
